import { ApiService, SearchPaginationOptions } from '@/features/api';
import { Comparison, SortOrder } from '@/features/api/types/pagination';

import {
  Payee,
  PayeeBindingModel,
  PayeesByIdsResponse,
  PayeesPage,
  SortableFieldTypes,
} from './interfaces';

class PayeesRestApiService {
  public static async create(bindingModel: PayeeBindingModel, companyId: string): Promise<Payee> {
    const url = new URL(`${import.meta.env.APP_URLS_API_URL}/v1/companies/${companyId}/payees`);

    return ApiService.put<Payee>(url.toString(), { body: bindingModel }, true);
  }

  public static async get(payeeId: string, companyId: string): Promise<Payee> {
    const url = new URL(
      `${import.meta.env.APP_URLS_API_URL}/v1/companies/${companyId}/payees/${payeeId}`
    );

    return ApiService.get<Payee>(url.toString(), null, true);
  }

  public static async getPayees(
    companyId: string,
    options: SearchPaginationOptions = null
  ): Promise<PayeesPage> {
    const url = new URL(
      `${import.meta.env.APP_URLS_API_URL}/v1/companies/${companyId}/payees/search`
    );
    return ApiService.post<PayeesPage>(url.toString(), { body: options }, true);
  }

  public static async getPayeesByIds(
    companyId: string,
    payeeIds: Array<string>
  ): Promise<PayeesByIdsResponse> {
    const url = new URL(
      `${import.meta.env.APP_URLS_API_URL}/v1/companies/${companyId}/payees/searchByIds`
    );
    const options = {
      payeeIds,
    };
    return ApiService.post<PayeesByIdsResponse>(url.toString(), { body: options }, true);
  }

  public static async getSuppliers(
    companyId: string,
    name?: string,
    resultsPerPage = 50
  ): Promise<PayeesPage> {
    return this.getPayees(companyId, {
      searchQuery: name,
      sortDetails: [
        {
          type: SortableFieldTypes.Name,
          order: SortOrder.Ascending,
        },
      ],
      resultsPerPage,
      filters: [
        {
          type: 'Type',
          value: 'Supplier',
          comparison: Comparison.Equals,
        },
      ],
    });
  }
}

export default PayeesRestApiService;
export type { Payee };
export { Comparison } from '@/features/api';
